<div class="inspections">
  <p class="main-case">להלן תוצאות הבדיקה לפי ת"י 1205:</p>
  <p class="case">תקן 1205</p>
  <table class="data-table">
    <thead>
      <tr>
        <th style="width: 10%">
          <strong>סעיף התקן</strong>
        </th>
        <th style="width: 43%">
          <strong>תיאור סעיף</strong>
        </th>
        <th style="width: 37%">
          <strong>הערה</strong>
        </th>
        <th style="width: 10%">
          <strong>מסקנה</strong>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="section">
          <span>{{
            inspection?.standard_1205?.systemInstallationAccordingSpec.section
          }}</span>
        </td>
        <td>
          <span>{{
            inspection?.standard_1205?.systemInstallationAccordingSpec?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205
                ?.systemInstallationAccordingSpec?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(
              inspection?.standard_1205?.systemInstallationAccordingSpec
            )
          }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>{{
            inspection?.standard_1205?.waterSupplyPipesInstallationAccordingSpec
              .section
          }}</span>
        </td>
        <td>
          <span>{{
            inspection?.standard_1205?.waterSupplyPipesInstallationAccordingSpec
              ?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205
                ?.waterSupplyPipesInstallationAccordingSpec?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(
              inspection?.standard_1205
                ?.waterSupplyPipesInstallationAccordingSpec
            )
          }}</span>
        </td>
      </tr>
    </tbody>
  </table>

  <p class="case">תקן 1205 חלק 1</p>
  <table class="data-table">
    <thead>
      <tr>
        <th style="width: 10%">
          <strong>סעיף התקן</strong>
        </th>
        <th style="width: 43%">
          <strong>תיאור סעיף</strong>
        </th>
        <th style="width: 37%">
          <strong>הערה</strong>
        </th>
        <th style="width: 10%">
          <strong>מסקנה</strong>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="section">
          <span>{{
            inspection?.standard_1205_part_1?.drinkingWaterSystem.section
          }}</span>
        </td>
        <td>
          <span>{{
            inspection?.standard_1205_part_1?.drinkingWaterSystem?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1?.drinkingWaterSystem
                ?.notes | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(inspection?.standard_1205_part_1?.drinkingWaterSystem)
          }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>2.2</span>
        </td>
        <td colspan="3"></td>
      </tr>
      <tr>
        <td class="section">
          <span>{{
            inspection?.standard_1205_part_1?.waterPipeInstallationAccordingSpec
              .section
          }}</span>
        </td>
        <td>
          <span>{{
            inspection?.standard_1205_part_1?.waterPipeInstallationAccordingSpec
              ?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1
                ?.waterPipeInstallationAccordingSpec?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(
              inspection?.standard_1205_part_1
                ?.waterPipeInstallationAccordingSpec
            )
          }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>2.2.8</span>
        </td>
        <td colspan="3"></td>
      </tr>
      <tr>
        <td rowspan="3"></td>
        <td>
          <span>{{
            inspection?.standard_1205_part_1?.hangingPointsGaps?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1?.hangingPointsGaps
                ?.notes | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(inspection?.standard_1205_part_1?.hangingPointsGaps)
          }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <span>{{
            inspection?.standard_1205_part_1?.verticalTube?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1?.verticalTube?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(inspection?.standard_1205_part_1?.verticalTube)
          }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <span>{{
            inspection?.standard_1205_part_1?.waterSupplyPipesPassage?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1
                ?.waterSupplyPipesPassage?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(
              inspection?.standard_1205_part_1?.waterSupplyPipesPassage
            )
          }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>2.3</span>
        </td>
        <td colspan="3"></td>
      </tr>
      <tr>
        <td rowspan="6"></td>
        <td>
          <span>{{
            inspection?.standard_1205_part_1?.sealingConnections?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1?.sealingConnections
                ?.notes | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(inspection?.standard_1205_part_1?.sealingConnections)
          }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <span>{{
            inspection?.standard_1205_part_1?.galvanizedSteelPipes?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1?.galvanizedSteelPipes
                ?.notes | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(
              inspection?.standard_1205_part_1?.galvanizedSteelPipes
            )
          }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <span>{{
            inspection?.standard_1205_part_1?.corrosionProtectedThread?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1
                ?.corrosionProtectedThread?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(
              inspection?.standard_1205_part_1?.corrosionProtectedThread
            )
          }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <span>{{
            inspection?.standard_1205_part_1?.plumbingMmadeOfSteel?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1?.plumbingMmadeOfSteel
                ?.notes | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(
              inspection?.standard_1205_part_1?.plumbingMmadeOfSteel
            )
          }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <span>{{
            inspection?.standard_1205_part_1?.galvanizedScrewedUpAbsorbers
              ?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1
                ?.galvanizedScrewedUpAbsorbers?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(
              inspection?.standard_1205_part_1?.galvanizedScrewedUpAbsorbers
            )
          }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <span>{{
            inspection?.standard_1205_part_1
              ?.galvanizedSteelPipesAccordingToStandard?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1
                ?.galvanizedSteelPipesAccordingToStandard?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(
              inspection?.standard_1205_part_1
                ?.galvanizedSteelPipesAccordingToStandard
            )
          }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>3.3</span>
        </td>
        <td colspan="3"></td>
      </tr>
      <tr>
        <td rowspan="4"></td>
        <td>
          <span>{{
            inspection?.standard_1205_part_1
              ?.pipeNominalDiameterForSingleFireHydrant?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1
                ?.pipeNominalDiameterForSingleFireHydrant?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(
              inspection?.standard_1205_part_1
                ?.pipeNominalDiameterForSingleFireHydrant
            )
          }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <span>{{
            inspection?.standard_1205_part_1
              ?.pipeNominalDiameterForMultiFireHydrants?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1
                ?.pipeNominalDiameterForMultiFireHydrants?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(
              inspection?.standard_1205_part_1
                ?.pipeNominalDiameterForMultiFireHydrants
            )
          }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <span>{{
            inspection?.standard_1205_part_1?.pipeNominalDiameterForCartwheel
              ?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1
                ?.pipeNominalDiameterForCartwheel?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(
              inspection?.standard_1205_part_1?.pipeNominalDiameterForCartwheel
            )
          }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <span>{{
            inspection?.standard_1205_part_1?.fireHydrantIsMarked?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1?.fireHydrantIsMarked
                ?.notes | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(inspection?.standard_1205_part_1?.fireHydrantIsMarked)
          }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>{{
            inspection?.standard_1205_part_1?.waterSupplyForFireExtinguishing
              .section
          }}</span>
        </td>
        <td>
          <span>{{
            inspection?.standard_1205_part_1?.waterSupplyForFireExtinguishing
              ?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1
                ?.waterSupplyForFireExtinguishing?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(
              inspection?.standard_1205_part_1?.waterSupplyForFireExtinguishing
            )
          }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>{{
            inspection?.standard_1205_part_1
              ?.drinkingWaterSupplyNetworkConnection.section
          }}</span>
        </td>
        <td>
          <span>{{
            inspection?.standard_1205_part_1
              ?.drinkingWaterSupplyNetworkConnection?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1
                ?.drinkingWaterSupplyNetworkConnection?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(
              inspection?.standard_1205_part_1
                ?.drinkingWaterSupplyNetworkConnection
            )
          }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>3.8.2</span>
        </td>
        <td colspan="3"></td>
      </tr>
      <tr>
        <td rowspan="2"></td>
        <td>
          <span>{{
            inspection?.standard_1205_part_1?.onlyMetalPipesInstalled?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1
                ?.onlyMetalPipesInstalled?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(
              inspection?.standard_1205_part_1?.onlyMetalPipesInstalled
            )
          }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <span>{{
            inspection?.standard_1205_part_1?.closingValvesSigns?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1?.closingValvesSigns
                ?.notes | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(inspection?.standard_1205_part_1?.closingValvesSigns)
          }}</span>
        </td>
      </tr>

      <tr>
        <td class="section">
          <span>3.8.3</span>
        </td>
        <td>
          <span>עמדת כיבוי אש בבניין תכלול ציוד זה לפחות :</span>
        </td>
        <td colspan="2"></td>
      </tr>
      <tr>
        <td rowspan="8"></td>
        <td>
          <span>{{
            inspection?.standard_1205_part_1?.fireHydrantExist?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1?.fireHydrantExist
                ?.notes | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(inspection?.standard_1205_part_1?.fireHydrantExist)
          }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <span>{{
            inspection?.standard_1205_part_1?.twoHosesExist?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1?.twoHosesExist?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(inspection?.standard_1205_part_1?.twoHosesExist)
          }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <span>{{
            inspection?.standard_1205_part_1?.multipurposeJumperExist?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1
                ?.multipurposeJumperExist?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(
              inspection?.standard_1205_part_1?.multipurposeJumperExist
            )
          }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <span>{{
            inspection?.standard_1205_part_1?.EquipmentApproved?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1?.EquipmentApproved
                ?.notes | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(inspection?.standard_1205_part_1?.EquipmentApproved)
          }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <span
            >בהתאם לדרישות הרשות המוסמכת אפשר להתקין עמדת כיבוי בעלת גלגלון
            כיבוי רב שימושי הכולל:</span
          >
        </td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>
          <span>{{ inspection?.standard_1205_part_1?.rubberTube?.title }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1?.rubberTube?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(inspection?.standard_1205_part_1?.rubberTube)
          }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <span>{{
            inspection?.standard_1205_part_1?.multipurposeLeaper?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1?.multipurposeLeaper
                ?.notes | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(inspection?.standard_1205_part_1?.multipurposeLeaper)
          }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <span>{{
            inspection?.standard_1205_part_1?.ballOpeningTap?.title
          }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.standard_1205_part_1?.ballOpeningTap
                ?.notes | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(inspection?.standard_1205_part_1?.ballOpeningTap)
          }}</span>
        </td>
      </tr>
    </tbody>
  </table>

  <div style="page-break-inside: avoid">
    <p class="case">תקן 1205 חלק 6</p>
    <table class="data-table">
      <thead>
        <tr>
          <th style="width: 10%">
            <strong>סעיף התקן</strong>
          </th>
          <th style="width: 43%">
            <strong>תיאור סעיף</strong>
          </th>
          <th style="width: 37%">
            <strong>הערה</strong>
          </th>
          <th style="width: 10%">
            <strong>מסקנה</strong>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="section">
            <span>{{
              inspection?.standard_1205_part_6?.plumbingPassedOpacityTest
                .section
            }}</span>
          </td>
          <td>
            <span>{{
              inspection?.standard_1205_part_6?.plumbingPassedOpacityTest?.title
            }}</span>
          </td>
          <td>
            <span
              *ngFor="
                let note of inspection?.standard_1205_part_6
                  ?.plumbingPassedOpacityTest?.notes
                  | filterBy : ['addNotesToReport'] : true
              "
              >{{ note.notes }}</span
            >
          </td>
          <td>
            <span>{{
              getConclusion(
                inspection?.standard_1205_part_6?.plumbingPassedOpacityTest
              )
            }}</span>
          </td>
        </tr>
        <tr>
          <td class="section">
            <span>{{
              inspection?.standard_1205_part_6
                ?.systemComponentsDescriptionPassed.section
            }}</span>
          </td>
          <td>
            <span>{{
              inspection?.standard_1205_part_6
                ?.systemComponentsDescriptionPassed?.title
            }}</span>
          </td>
          <td>
            <span
              *ngFor="
                let note of inspection?.standard_1205_part_6
                  ?.systemComponentsDescriptionPassed?.notes
                  | filterBy : ['addNotesToReport'] : true
              "
              >{{ note.notes }}</span
            >
          </td>
          <td>
            <span>{{
              getConclusion(
                inspection?.standard_1205_part_6
                  ?.systemComponentsDescriptionPassed
              )
            }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <authority-labs-summary-notes
    [summaryNotes]="inspection?.summaryNotes"
    [root]="true"
  ></authority-labs-summary-notes>
</div>
